import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './NftCard.css';
import NFT_TEMPLATES from '../config/nftTemplates';

function NftCard({ nft, isActive, onClick, onClose, onClaim, style }) {
  const template = NFT_TEMPLATES.find(t => t.template_id === nft.template_id);
  const imageSrc = template?.img;
  const name = template?.nft_name || 'Unknown NFT';

  const [remaining, setRemaining] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = Math.floor(Date.now() / 1000);
      const diff = Math.max(0, nft.next_claim - now);
      setRemaining(diff);
    }, 1000);
    return () => clearInterval(interval);
  }, [nft.next_claim]);

  const formatTime = (s) => {
    const h = String(Math.floor(s / 3600)).padStart(2, '0');
    const m = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
    const sec = String(s % 60).padStart(2, '0');
    return `${h}:${m}:${sec}`;
  };

  return (
    <motion.div
      layout
      className={`nft-card-container ${isActive ? 'active' : ''}`}
      style={style}
      onClick={() => onClick(nft.asset_id)}
    >
      <div className="nft-card-timer">{formatTime(remaining)}</div>
      <img className="nft-card-image" src={imageSrc} alt={name} />
    </motion.div>
  );
}

export default NftCard;
